import { IS_CLIENT } from '@repo/common-utils';
import { atomWithStorage } from 'jotai/utils';

// 환급 취소 데이터 타입
export type CancelData =
  | {
      refundId: string;
      name: string;
      businessType: 'corps' | 'indis';
    }
  | undefined;

// sessionStorage 키 상수
const CANCEL_DATA_KEY = 'bznav-refund-cancel-data';

// 환급 취소 데이터 atom
export const cancelDataAtom = atomWithStorage<CancelData>(CANCEL_DATA_KEY, undefined, {
  getItem: (key) => {
    if (!IS_CLIENT) return undefined;
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  },
  setItem: (key, value) => {
    if (!IS_CLIENT) return;
    if (value === undefined) {
      sessionStorage.removeItem(key);
      return;
    }
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  removeItem: (key) => {
    if (!IS_CLIENT) return;
    sessionStorage.removeItem(key);
  }
});
